{
  "pageTitle": "وظائف",
  "heroTitle1": "انضم إلى رحلتنا",
  "heroTitle2": "لتلهم وتمكين",
  "heroTitle3": "قادة المستقبل",
  "heroDescription": "يمنحك الانضمام إلى فريق مدرسة منارة فرصة لترك بصمتك وإرثك من خلال الإسهام في صنع قادة المستقبل بدعم من الخبراء في هيئة التدريس ذوي الخبرة الواسعة في إدراك إمكانات الطلاب ذوي القدرات الاستثنائية.",
  "cultureTitle1": "ثقافة المدرسة",
  "cultureTitle2": "وبيئة العمل",
  "cultureText": "يضم مُجتمع منارة خبراء شغوفين ذوي خبرة والتزام في العمل مع المراهقين وتأهيلهم. يتميز فريق عمل المدرسة بالنزاهة والتعاون والتعاطف والحرص على الطلاب، ويعمل في إطار من التنوع والإنصاف والاحترام، ويقود بمرونة وإيجابية.",
  "cultureButton": "اقرأ بورتريه مُعلم",
  "benefits": "المزايا المالية والمعنوية",
  "andPolicies": "والسياسات",
  "exploreOur": "تعرف على أهم",
  "keyTeams": "فرق العمل في المدرسة",
  "manaraCurrent": "الفرص المتاحة",
  "opportunities": "حاليًا في مدرسة منارة",
  "opportunitiesError": "فشل في الحصول على بيانات الفرص المتاحة",
  "careersCTA1": "هل ترغب في التقديم؟",
  "careersCTA2": "انضم إلينا",

  "heroAction": "استكشف الوظائف",

  "educationalTitle1": "فلسفتنا",
  "educationalTitle2": "التعليمية",
  "educationalText": "في مدرسة منارة، يتجاوز التعليم الأكاديمي ليشمل النمو الشخصي والنزاهة والغاية. من خلال نهج شامل، نقدم مسارات تعليمية فردية تكرم نقاط القوة الفردية لكل طالب، وتعزز التعلم القائم على الاستفسار لحل المشكلات العملية، وتعزز المواطنة العالمية من خلال تبني التنوع وتشجيع الأثر الإيجابي على المجتمع.",

  "ourEducational": "برنامجنا",
  "program": "التعليمي",

  "join": "انضم إلى",
  "ourTeam": "فريقنا",

  "apply": "قدم الآن",
  "position": "المنصب",
  "location": "الموقع",
  "department": " القسم",
  "type": "النوع",
  "explore": "استكشف",
  "oppurtunities": "الفرص المتاحة",
  "thankyou": "شكرًا لك",
  "thankyouMessage": "تم تقديم طلبك بنجاح. سيقوم فريقنا بمراجعة طلبك بعناية. نحن نقدر اهتمامك بالانضمام إلى مدرسة منارة ونتطلع إلى معرفة المزيد عنك.",

  "firstNameLabel": "اسم المتقدم",
  "firstNamePlaceholder": "محمد",
  "firstNameError": "اسم المتقدم مطلوب!",
  "cvLabel": "السيرة الذاتية",
  "cvPlaceholder": "قم بتحميل سيرتك الذاتية",
  "cvError": "السيرة الذاتية مطلوبة!",
  "submit": "تقديم الطلب",
  "messageLabel": "أي شيء آخر تود إضافته أو مشاركته؟",
  "messagePlaceholder": "أي شيء آخر تود إضافته أو مشاركته؟",

  "emailLabel": "البريد الإلكتروني الأساسي",
  "emailPlaceholder": "example@example.com",
  "emailError": "يجب ادخال بريد إلكتروني يوافق الصيغة التالية ex@example.com",
  "emailRequired": "مطلوب البريد الإلكتروني!",
  "phoneNumberLabel": "رقم الهاتف الأساسي",
  "phoneNumberPlaceholder": "010 000 000 00",
  "phoneNumberRequired": "مطلوب رقم الهاتف!"
}
